export const spmConfig = {
  // 文章
  article: {
    spm1: 'c17801.d17801'/** data-spm-desc: 文章-获取文章信息 **/,
    spm2: 'c17801.d17802'/** data-spm-desc: 文章-通过iframe获取文章信息 **/,
    spm3: 'c17801.d17803'/** data-spm-desc: 文章-监听页面滚动 **/,
  },
  // 宣传册
  brochure: {
    spm1: 'c17810.d17804'/** data-spm-desc: 宣传册-浏览到页尾上报 **/,
    spm2: 'c17810.d17805'/** data-spm-desc: 宣传册-获取宣传册数据 **/,
    spm3: 'c17810.d17806'/** data-spm-desc: 宣传册-通过iframe获取宣传册数据 **/,
    spm4: 'c17810.d17807'/** data-spm-desc: 宣传册-跳转到指定页 **/,
    spm5: 'c17810.d17808'/** data-spm-desc: 宣传册-左右滑动 **/,
    spm6: 'c17810.d17809'/** data-spm-desc: 宣传册-中间内容点击翻页 **/,
  },
  // 表单
  form: {
    spm1: 'c17803.d17810'/** data-spm-desc: 表单-页面加载完成 **/,
    spm2: 'c17803.d17811'/** data-spm-desc: 表单-页面滚动 **/,
    spm3: 'c17803.d17812'/** data-spm-desc: 表单-提交表单 **/,
    spm4: 'c17803.d17813'/** data-spm-desc: 表单-点击授权手机号 **/,
    spm5: 'c17803.d17847'/** data-spm-desc: 表单-提交成功返回数据 **/,
    spm6: 'c17803.d17848'/** data-spm-desc: 表单-获取来源 **/,
  },
  // h5
  h5: {
    spm1: 'c17804.d17814'/** data-spm-desc: h5-获取数据 **/,
    spm2: 'c17804.d17815'/** data-spm-desc: h5-通过iframe获取数据 **/,
    spm3: 'c17804.d17816'/** data-spm-desc: h5-浏览到页尾上报 **/,
  },
  // 任意链接
  link: {
    spm1: 'c17805.d17817'/** data-spm-desc: 任意链接-获取任意链接详情 **/,
  },
  // 营销视频
  mkVideo: {
    spm1: 'c17807.d17818'/** data-spm-desc: 营销视频-获取营销视频详情 **/,
    spm2: 'c17807.d17819'/** data-spm-desc: 营销视频-通过iframe获取任意链接详情 **/,
    spm3: 'c17807.d17820'/** data-spm-desc: 营销视频-视频播放完成上报 **/,
    spm4: 'c17807.d17821'/** data-spm-desc: 营销视频-播放视频 **/,
  },
  // 海报
  poster: {
    spm1: 'c17802.d17822'/** data-spm-desc: 海报-获取海报 **/,
    spm2: 'c17802.d17823'/** data-spm-desc: 海报-获取海报详情 **/,
  },
  // 视频
  video: {
    spm1: 'c17809.d17824'/** data-spm-desc: 视频-视频分享数据处理 **/,
    spm2: 'c17809.d17825'/** data-spm-desc: 视频-获取视频详情 **/,
  },
  bindMobile: {
    spm1: 'c17813.d17826'/** data-spm-desc: 绑定手机号流程-判断是否需要绑定手机号开始 **/,
    spm2: 'c17813.d17827'/** data-spm-desc: 绑定手机号流程-判断是否需要绑定手机号结束 **/,
    spm3: 'c17813.d17828'/** data-spm-desc: 绑定手机号流程-手机号跳转绑定组件开始 **/,
    spm4: 'c17813.d17829'/** data-spm-desc: 绑定手机号流程-手机号跳转绑定组件完成 **/,
    spm5: 'c17813.d17830'/** data-spm-desc: 绑定手机号流程-手机号跳转开始 **/,
    spm6: 'c17813.d17831'/** data-spm-desc: 绑定手机号流程-手机号跳转完成 **/,
    spm7: 'c17813.d17832'/** data-spm-desc: 绑定手机号流程-手机号跳转失败 **/,
    spm8: 'c17813.d17836'/** data-spm-desc: 绑定手机号流程-判断是否需要绑定手机号开始请求 **/,
    spm10: 'c17813.d17837'/** data-spm-desc: 绑定手机号流程-三方应用判断 **/,
    spm11: 'c17813.d17838'/** data-spm-desc: 绑定手机号流程-商城 **/,
    spm12: 'c17813.d17839'/** data-spm-desc: 绑定手机号流程-是否登录判断 **/,
    spm13: 'c17813.d17840'/** data-spm-desc: 绑定手机号流程-进入绑定组件 **/,
    spm14: 'c17813.d17841'/** data-spm-desc: 绑定手机号流程-进入绑定组件执行跳转 **/,
    spm15: 'c17813.d17842'/** data-spm-desc: 绑定手机号流程-进入全局绑定事件 **/,
    spm17: 'c17813.d17843'/** data-spm-desc: 绑定手机号流程-进入全局绑定事件跳转失败 **/,
    spm16: 'c17813.d17845'/** data-spm-desc: 绑定手机号流程-加载微信完成 **/,
    spm9: 'c17813.d17846'/** data-spm-desc: 绑定手机号流程-载微信成功 **/,
  },
  login: {
    spm1: 'c17814.d17833'/** data-spm-desc: 登录-开始 **/,
    spm2: 'c17814.d17834'/** data-spm-desc: 登录-结果 **/,
    spm3: 'c17814.d17835'/** data-spm-desc: 登录-跳转 **/,
    spm4: 'c17814.d17844'/** data-spm-desc: 登录-跳转then **/,
  },
}
